/** @prettier */

import {Box, Grid} from '@mui/material';
import {useEffect, useState} from 'react';
import {
  useLocation,
  useParams,
  Outlet,
  useOutletContext,
  LoaderFunctionArgs,
} from 'react-router-dom';

//MTH component import
import GroupSettingTreeView from '../../component/GroupSettingTreeView';
import RegistrationBreadcrumbs from '../../component/RegistrationBreadcrumbs';
//API import
import {getCompositionsSitesBySiteID} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {checkUnitExistence} from '../../functions/checkUnitExistence';
import type {unitExistence} from '../../functions/checkUnitExistence';

type OutletContextType = {
  allGroupInfo: apiIF.res.getCompositionsGroups | null;
  setAllGroupInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGroups | null>
  >;
};

type loaderReturn = 'OK';
export async function loader({
  params,
}: LoaderFunctionArgs): Promise<loaderReturn | undefined> {
  //パスパラメータを取得できない場合
  if (params.siteID === undefined) {
    return undefined;
  }

  try {
    const promises = [];
    //サイトの情報を取得
    promises.push(getCompositionsSitesBySiteID(params.siteID));
    //全てのユニットの登録状況を取得
    promises.push(checkUnitExistence(params.siteID, true));
    const result = await Promise.all(promises);

    const siteInfo = result[0] as apiIF.res.getCompositionsSitesBySiteID;
    const unitExistence = result[1] as unitExistence;

    if (
      (unitExistence.hasHyozanIU === false &&
        unitExistence.hasHCCVQ === false) ||
      siteInfo['site-authority'] !== 'admin'
    ) {
      throw new Error(
        'Required equipment not registered or insufficient permission'
      );
    }

    return 'OK';
  } catch {
    return undefined;
  }
}

/**
 * グループ一覧
 * @param props props
 * @returns JSX.Element
 */
const GroupMain = (props: {
  /** 登録している空調機の種類 */
  unitSystem: 'rt' | 'modbus';
}) => {
  //URL取得
  const location = useLocation();
  //パスパラメータ取得
  const {groupID} = useParams();

  const [allGroupInfo, setAllGroupInfo] =
    useState<apiIF.res.getCompositionsGroups | null>(null); //サイトに登録されているすべてのグループの情報
  const [displayGroupInfo, setDisplayGroupInfo] =
    useState<apiIF.resParameters.groupInformations | null>(null); //表示しているグループの情報
  const [defaultExpanded, setDefaultExpanded] = useState<string[]>(['none']); //ツリービューで初期に開く階層を指定（nodeIDで指定）

  useEffect(() => {
    //ツリービューで初期に開く階層を決定
    if (
      groupID !== undefined &&
      (location.pathname.endsWith('hyozan-group-layout-registration') ||
        location.pathname.endsWith('modbus-group-layout-registration'))
    ) {
      //グループレイアウト画面
      setDefaultExpanded(['Floor0', groupID]);
    } else {
      //グループ一覧画面
      setDefaultExpanded(['Floor0']); //フロアの設定がないため一階で固定
    }

    //表示しているグループの情報を取得
    if (groupID !== undefined && allGroupInfo !== null) {
      const temp = allGroupInfo['group-informations'].find(
        groupInfo => groupInfo['group-id'] === groupID
      );
      if (temp !== undefined) {
        setDisplayGroupInfo(temp);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Box className="groupSetting">
      <Grid container>
        {/* ツリービュー */}
        {/** lgより小さい画面では非表示 */}
        <Grid item lg={2.5} sx={{display: {xs: 'none', lg: 'block'}}}>
          <GroupSettingTreeView
            defaultExpanded={defaultExpanded}
            groupInfoData={allGroupInfo}
            unitSystem={props.unitSystem}
          />
        </Grid>
        <Grid item xs={12} lg={9.5}>
          {/* パンくずリスト */}
          <RegistrationBreadcrumbs
            groupName={
              displayGroupInfo === null
                ? undefined
                : displayGroupInfo['group-name']
            }
          />
          <Outlet
            context={{
              allGroupInfo: allGroupInfo,
              setAllGroupInfo: setAllGroupInfo,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
const useOutlet = () => useOutletContext<OutletContextType>();

export {useOutlet};
export default GroupMain;
